import { GameApp } from "./core/GameApp";

const { regClass } = Laya;

@regClass('e60XQm7tTY2BwFAdxb8D1g')
export class Main extends Laya.Scene {
    private app: GameApp;

    onAwake(): void {
        this.app = new GameApp();
        this.addChild(this.app);
        Laya.stage.on(Laya.Event.RESIZE, this, this.onResizeStage);
        console.log("成语红包王 started with LayaAir 3.4.0");
    }

    onDestroy(): void {
        Laya.stage.off(Laya.Event.RESIZE, this, this.onResizeStage);
    }

    private onResizeStage(): void {
        if (!this.app) return;
        this.app.height = Math.max(1624, Laya.stage.height);
    }
}
